module.exports = __webpack_public_path__ + "lp/img/up-icon-trouble.c36744e4.svg";